<template>
    <div id="home">
        <button type="button" class="btn btn-primary" @click="setState('dashboard')">Student</button>
        <button type="button" class="btn btn-primary" @click="setState('triage')">Triage</button>
        {{ inqueue }}
        <div v-if="triageSubmit" class="container">
            <!-- Triage submission -->
            <div class="alert alert-success" role="alert">
                <h4 class="alert-heading"><i class="fas fa-user-check"></i> Your academic counselling questionnaire has
                    been submitted!</h4>
                <hr>
                <p>You have been placed in the queue. Please continue to monitor the Check-In Status section to get
                    up-to-date information on your upcoming academic counselling appointment.
                </p>
            </div>
        </div>
        <div v-if="capacityMet || capacityThresholdMet" class="container">
            <div v-if="capacityMet" class="alert alert-danger" role="alert">
                <h4 class="alert-heading"><i class="fas fa-exclamation-circle"></i> 
                    Check-in capacity has been reached for today, but <b>you will still be able to see a counsellor during this drop-in period</b>. 
                    Please be patient and remain in the queue. Note that you will no longer be able to access the drop-in dashboard. 
                    You will receive an email informing you when the counsellor is ready to see you. Thank you for your patience as we proceed through this busy time.  </h4>
            </div>
            <div v-else class="alert alert-warning" role="alert">
                <h4 class="alert-heading"><i class="fas fa-exclamation-circle"></i> Limited appointments are available.
                    Please complete form as soon as possible to hold your spot.</h4>
            </div>
        </div>

        <!-- Dashboard -->
        <student-dashboard v-if="state == 'dashboard'" :assignedCounsellor="assignedCounsellor"
            :notificationsData="notificationsData" :triageData="triageData" :user="user" @refreshData="refreshData">
        </student-dashboard>
        <!-- Triage Form -->
        <student-triage v-else-if="state == 'triage'" :capacityMet="capacityMet" :counsellorsData="counsellorsData"
            :triageSettings="triageSettings" :user="user" @refreshData="refreshData" @setState="setState"
            @setTriageData="setTriageData" @setTriageSubmit="setTriageSubmit">
        </student-triage>
        <!-- Loader -->
        <div v-else class="container-fluid h-100">
            <div class="d-flex justify-content-center mt-5">
                <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
            <div class="text-center mt-1">
                Loading
            </div>
        </div>
    </div>
</template>

<script>
import auth from '../../js/auth';
import StudentDashboard from './Dashboard.vue';
import StudentTriage from './Triage.vue';

export default {
    name: 'student-home',
    components: {
        StudentDashboard,
        StudentTriage
    },
    props: {
        user: {
            type: Object
        }
    },
    data() {
        return {
            assignedCounsellor: {},
            capacityMet: 0,
            capacityThresholdMet: 0,
            counsellorsData: [],
            notificationsData: [],
            refreshCycle: '',
            state: '',
            triageData: {
                counsellor: '',
                counsellorRequest: '',
                createdTimestamp: '',
                currentModuleCombination: '',
                degree: '',
                desiredModuleCombination: '',
                firstName: '',
                homeFaculty: '',
                id: '',
                lastName: '',
                mail: '',
                questions: [],
                studentNumber: '',
                username: '',
                yearOfStudy: ''
            },
            triageSettings: {
                appointmentType: 'all'
            },
            triageSubmit: false
        }
    },
    methods: {
        getNotificationData() {
            const that = this;
            const api = `https://${location.hostname}/cgi-bin/mkvn-cardservices-backend/api.pl?notificationsGet`;

            // GET request
            fetch(api)
                .then(function (response) {
                    // Return response
                    return response.json();
                })
                .then(function (json) {
                    // TODO: Remove, used for testing
                    //console.log(json);
                    if (json.result.match(/OK/i)) {
                        that.notificationsData = json.data || that.notificationsData;
                    }
                })
                .catch(function (error) {
                    // TODO: Remove, used for testing
                    //console.log(error);
                })
        },
        getStudentData() {
            const that = this;
            const api = `https://${location.hostname}/cgi-bin/mkvn-cardservices-backend/api.pl?triageGet`;

            // GET request
            fetch(api)
                .then(function (response) {
                    // Return response
                    return response.json();
                })
                .then(function (json) {
                    // TODO: Remove, used for testing
                    //console.log(json);
                    // Inqueue
                    if (json.result.match(/OK/i)) {
                        that.triageData = json.data || that.triageData;
                        that.setState('dashboard');
                    } else {
                        that.setState('triage');
                    }

                    // Retrieve triage form settings
                    that.triageSettings.appointmentType = json.appointmentType || that.triageSettings.appointmentType;

                    // Retrieve counsellors data
                    that.counsellorsData = json.counsellors || that.counsellorsData;

                    // Retrieve capacity met
                    if (json.status && 'capacityThresholdMet' in json.status) {
                        that.capacityThresholdMet = json.status.capacityThresholdMet;
                    }

                    // Resolve queue status
                    if (json.queueStatus == "dequeued") {
                        that.redirectSession();
                    }

                    // Resolve capacity met
                    if (json.status && json.status.closureType && json.status.closureType.type.match(/capacity met/gi)) {
                        that.capacityMet = 1;
                        that.redirectSessionCapacityMet();
                    }
                })
                .catch(function (error) {
                    // TODO: Remove, used for testing
                    console.log(error);
                    // Set error result
                    that.queueResult = 'error';
                })
        },
        redirectSession() {
            let user = auth.getUser();

            if (user) {
                // Kill session
                auth.destroy_session();

                // Redirect user session
                this.$router.push({
                    path: `/unauthenticated/dequeued`
                });
            }
        },
        redirectSessionCapacityMet() {
            let that = this;
            let user = auth.getUser();

            if (user) {
                setTimeout(function () {
                    // Kill session
                    auth.destroy_session();

                    // Redirect user session
                    that.$router.push({
                        path: `/unauthenticated/noappointments`
                    });
                }, 30000);
            }
        },
        refreshData() {
            // Update data
            this.getStudentData();
            this.getNotificationData();
        },
        setState(state) {
            this.state = state;
        },
        setTriageData(data) {
            this.triageData = data;
        },
        setTriageSubmit(bool) {
            this.triageSubmit = bool;
            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        }
    },
    created() {
        const that = this;

        // Retrieve database
        this.refreshData();

        // Auto refresh
        this.refreshCycle = setInterval(function () {
            that.refreshData();
        }, 60000);
    },
    beforeDestroy() {
        // Clear refresh function
        clearInterval(this.refreshCycle);
    },
    destroyed() {
        // Clear refresh function
        clearInterval(this.refreshCycle);
    }
}
</script>